<template>
  <div>
    <a-row>
      <a-col v-for="card in LIST_NAME" :key="card.name" :span="12">
        <CardListUser :name="card.name" :card-title="card.title" />
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { name } from "store/storages/cookieStorage";

const LIST_NAME = [
  {
    name: "leaders-and-managers-approval",
    title: "Leaders & Managers for approval",
  },
  { name: "map-position-sam", title: "Sales Admin Managers" },
  { name: "map-position-bu", title: "BU" },
  { name: "map-position-cfo", title: "CFO" },
  { name: "map-position-ceo", title: "CEO" },
  { name: "can-add-document-iso", title: "Create Document ISO" },
  {
    name: "view-report-document-in-out",
    title: "Can View List All Document In / Out",
  },
  {
    name: "helpers-create-helpdesk",
    title: "Can create support tickets for others",
  },
  {
    name: "hr-form-viewers",
    title: "Hr form viewers",
  },
  {
    name: "position-admin-managers",
    title: "Position admin managers",
  },
  {
    name: "position-hr-cb",
    title: "Position Hr C&B",
  },
  {
    name: "document-iso-managers",
    title: "Document ISO Managers",
  },
  {
    name: "map-position-legal",
    title: "LEGAL",
  },
  {
    name: "map-position-fin",
    title: "FIN",
  },
  {
    name: "interview-assessment-form-viewers",
    title: "INTERVIEW ASSESSMENT FORM VIEWERS",
  },
  {
    name: "head-count-form-viewers",
    title: "HEAD COUNT FORM VIEWERS",
  },
  {
    name: "procedure-admins",
    title: "PROCEDURE ADMIN",
  },
  {
    name: "form-newcomer-viewers",
    title: "FORM NEWCOMER VIEWERS",
  },
];

export default {
  components: {
    CardListUser: () => import("./CardListUser"),
  },
  data() {
    return {
      LIST_NAME,
    };
  },
};
</script>
